import { compact } from "lodash-es"
import type { CountryIsoCode } from "@oysterhr/schema"
import { EmploymentTemplateStatus } from "@oysterhr/schema"
import type { TFunction } from "react-i18next"
import type { HiringTemplateCardFragment } from "../../components/HiringTemplateCard"

export const makeFilterAndSortActiveCardsByRelevance =
  (countryCode: CountryIsoCode) =>
  (templates: HiringTemplateCardFragment[] | undefined = []): HiringTemplateCardFragment[] => {
    const nationalTemplates =
      templates.filter(
        template => template?.countryCode != null && template?.countryCode === countryCode,
      ) ?? []
    const globalTemplates = templates.filter(template => template?.countryCode === null) ?? []
    return compact(
      [...nationalTemplates, ...globalTemplates].filter(
        template => template?.status === EmploymentTemplateStatus.Active,
      ),
    )
  }

export const makeLimitCards =
  (limit?: number) =>
  (templates: HiringTemplateCardFragment[] | undefined = []) => {
    if (limit) return templates.slice(0, limit)
    return templates ?? []
  }

export const getHiringTemplateSelectionTabs = (
  t: TFunction,
  employmentTemplates: HiringTemplateCardFragment[],
  oysterTemplates: HiringTemplateCardFragment[],
) =>
  [
    {
      label: t("listTemplates.tabs.allTemplates"),
      fragment: "all-templates" as const,
      endAdornment: <>{[employmentTemplates, oysterTemplates].flat().length}</>,
    },
    {
      label: t("listTemplates.tabs.myTemplates"),
      fragment: "my-templates" as const,
      endAdornment: <>{[employmentTemplates].flat().length}</>,
    },
    {
      label: t("listTemplates.tabs.oysterTemplates"),
      fragment: "oyster-templates" as const,
      endAdornment: <>{[oysterTemplates].flat().length}</>,
    },
  ] as const
